import { useMemo } from 'react';
import { useDeliveryWindows } from '~/shared/contexts/DeliveryWindowsContext';
import { formatWindowRange } from '~/shared/utils/delivery-window';

type WindowBucket = {
  start: number;
  end: number;
};

type WindowSelectProps = {
  value: WindowBucket | null | undefined;
  onChange: (window: WindowBucket | null) => void;
  includeEmpty?: boolean;
  emptyLabel?: string;
};

export function WindowSelect({ value, onChange, includeEmpty = true, emptyLabel = '--' }: WindowSelectProps) {
  const { windows, loading } = useDeliveryWindows();

  const windowOptions = useMemo(() => {
    return windows.map(w => ({
      value: `${w.start}-${w.end}`,
      label: formatWindowRange(w),
      start: w.start,
      end: w.end,
    }));
  }, [windows]);

  const currentValue = value ? `${value.start}-${value.end}` : '';

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const v = e.target.value;
    if (!v) {
      onChange(null);
      return;
    }
    const [start, end] = v.split('-').map(Number);
    onChange({ start, end });
  };

  if (loading) {
    return <select disabled><option>Loading...</option></select>;
  }

  return (
    <select value={currentValue} onChange={handleChange}>
      {includeEmpty && <option value="">{emptyLabel}</option>}
      {windowOptions.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
